
import {
  Obra
} from '../index';


export class ObraServico {
  "ObraId";
  "Servico";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraServico`.
   */
  static getModelName() {
    return "ObraServico";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraServico for dynamic purposes.
  **/
  static factory(data) {
    return new ObraServico(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraServico',
      plural: 'ObraServicos',
      path: 'ObraServicos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "Servico": {
          name: 'Servico',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraServico.js